module.exports = __webpack_public_path__ + "static/media/hero.1ba6f7ca.jpg";